import Axios from 'axios';
import jwtDecode, { JwtDecodeOptions } from 'jwt-decode';
import { BASE_URL } from '../config/urls';
import { UserIdentity, AuthProvider } from 'react-admin';
import { isFuture } from 'date-fns';

type LoginInput = {
  username: string;
  password: string;
};

type DecodedToken = {
  exp: number;
  iat: number;
  sub: string;
  id: number;
  role: string;
  name: string;
  email: string;
};
export default {
  login: async ({ username, password }: LoginInput) => {
    const result = await Axios.post(`${BASE_URL}/auth/admin`, {
      username,
      password,
    }).then((res) => res.data);
    if (result && result.token) {
      localStorage.setItem('token', result.token);
      Axios.defaults.headers.common['Authorization'] = `Bearer ${result.token}`;
      return Promise.resolve(result);
    } else {
      return Promise.reject();
    }
  },
  logout: () => {
    localStorage.removeItem('token');
    Axios.defaults.headers.common['Authorization'] = '';
    return Promise.resolve();
  },
  checkAuth: async () => {
    const token = localStorage.getItem('token');
    if (token) {
      const result = await Axios.get(`${BASE_URL}/auth/userinfo`)
        .then((res) => Promise.resolve(res.data))
        .catch((err) => {
          return Promise.reject();
        });
      return result;
    }
    return Promise.reject();
  },

  checkError: (error: { status: any }) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      //  localStorage.removeItem('token');
      // Axios.defaults.headers.common['Authorization'] = '';
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  getIdentity: async () => {
    const result = await Axios.get(`${BASE_URL}/auth/userinfo`).then(
      (res) => res.data
    );
    if (result) {
      const user: UserIdentity = {
        id: result.id,
        fullName: result.name || 'full name',
        avatar: '',
      };
      console.log('result', result);
      return Promise.resolve(user);
    }
    return Promise.reject({});
  },
  getPermissions: () => Promise.resolve(),
  getRoles: () => Promise.reject('Not implemented'),
};
